import React from "react";
import { Modal, Layout, Tooltip, Button } from "antd";
import DayCenterPatient from "../../dayCenterPatient";
import { CloseOutlined } from "@ant-design/icons";

const DayCenterPatientModal = ({ visible, onCancel, record }) => {
  const modalStyles = {
    body: {
      height: "100vh",
      width: "100vw",
      padding: "10px",
    },
  };

  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={modalStyles}
      className={"no-padding no-border-radius"}
      closable={false}
      open={visible}
      footer={null}
      destroyOnClose={true}
    >
      <Layout style={{ background: "transparent" }}>
        <Tooltip title="close">
          <Button
            onClick={onCancel}
            size="large"
            style={{ position: "absolute", left: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        <div style={{ paddingTop: "0px" }}>
          <DayCenterPatient record={record} />
        </div>
      </Layout>
    </Modal>
  );
};

export default DayCenterPatientModal;
